import api from "../api";

let _isLocked;

export default {
    created(){
        const vm = this;
        
        api.validateWritePermission()
            .then(
                () => vm.hasWritePermission = true,
                () => vm.hasWritePermission = false
            );
        
        api.validateDeletePermission()
            .then(
                () => vm.hasDeletePermission = true,
                () => vm.hasDeletePermission = false
            );
    },
    methods: {
        $_setLockedState(isLocked){
            _isLocked = isLocked;
            
            //_isLocked is 'global' and thus not reactive
            this.$forceUpdate();
        }
    },
    watch: {
        hasWritePermission(value){
            //Treat both the same for the time being
            this.hasSpecialWritePermission = value;
        }
    },
    computed: {
        canWrite(){
            const vm = this;
            
            //Special write permission is always allowed to write, lock, and unlock
            return vm.hasSpecialWritePermission || (!_isLocked && vm.hasWritePermission);
        },
        isLocked: {
            get() {
                return _isLocked;
            }
        }
    },
    data: function(){
        return {
            //Our privates should NOT be prefixed with $_; this seems to tell Vue to make them not reactive(?)
            
            //Initialise both values with NULL to ensure our watch functions get triggered
            //when the actual value is set
            hasWritePermission: null,

            //TODO: Implement
            hasSpecialWritePermission: null,
            
            hasDeletePermission: null
        }
    }
}